import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import {Provider} from 'react-redux';
import {applyMiddleware, createStore, compose} from 'redux';
import thunk from 'redux-thunk';
import reducer from './Reducers/index';
import initialState from './Store';

const middleware = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, initialState, composeEnhancers(applyMiddleware(...middleware)));

ReactDOM.render(
    <Provider store={store}><App/></Provider>, document.getElementById("root"));


// WEBPACK FOOTER //
// ./src/index.jsx